<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part">MRS. DALLOWAY</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?bf6f2488